import { all } from 'redux-saga/effects';
import authSaga from './auth/saga';
import reportSaga from './report/saga';
import optionlistSaga from './optionlist/saga';
import accessRightSaga from './accessright/saga';
import userSaga from './user/saga';
import accessGroupSaga from './accessgroup/saga';
import moduleSaga from './module/saga';
import accessGroupUserSaga from './accessgroupuser/saga';
import jobPostSaga from './jobpost/saga';
import myProfileSaga from './myprofile/saga';
import jobApplicantSaga from './jobapplicant/saga';
import referralSaga from './referral/saga';

function* rootSaga() {
  yield all([
    authSaga(),
    reportSaga(),
    optionlistSaga(),
    accessRightSaga(),
    userSaga(),
    accessGroupSaga(),
    moduleSaga(),
    accessGroupUserSaga(),
    jobPostSaga(),
    myProfileSaga(),
    jobApplicantSaga(),
    referralSaga(),
  ]);
}

export default rootSaga;
